export default "__VITE_ASSET__DGiQ9jpa__"